export enum ModalActionType {
    CONFIRM,
    CANCEL
}

export class ModalAction {
    constructor(public action: ModalActionType, public params?: any) {}
}
